import { VerifyAccountInviteRequestBody } from "@syla/shared/types/requests/VerifyAccountInviteRequestBody";
import { VerifyAccountInviteSuccessResponse } from "@syla/shared/types/responses/VerifyAccountInviteResponse";
import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function verifyAccountInvite(
  params: VerifyAccountInviteRequestBody,
): Promise<VerifyAccountInviteSuccessResponse> {
  try {
    const { data } = await axios.post<VerifyAccountInviteSuccessResponse>(
      "/accounts/accept-invite",
      params,
    );
    return data;
  } catch (error) {
    throwSylaApiError(error);
  }
}
